import { prepareMessages } from '@creditinfo-ui/messages/node';

export const m = prepareMessages('modals', [
	['cancel', 'Cancel'],
	['close', 'Close'],
	['confirm', 'Confirm'],
]);
